import { CustomFormField } from "./CustomFormFields";
import { LanguageCode, LocalizedText } from "./LanguageCode";

export const FormCategories = ['ergonomics'] as const;
export type FormCategory = typeof FormCategories[number];

export type CustomForm = {
    id:string,
    activityId:string,
    templateId:string,
    category:FormCategory
    
    publicLinkKey:string,
    
    defaultLanguageCode:LanguageCode,
    
    name:LocalizedText[],
    description:LocalizedText[],
    introText:LocalizedText[],
    
    fields:CustomFormField[]
}